import React from "react";
import PropTypes from "prop-types";
import { styled, Typography } from "@material-ui/core";

const TitleContainer = styled("div")({
  display: "flex",
  justifyContent: "center",
  padding: 16,
  marginTop: 8,
  marginBottom: 16
});

const StyledTypography = styled(Typography)({
  fontFamily: "aktiv-grotesk",
  fontSize: 28,
  fontWeight: 900,
  lineHeight: "35px",
  textAlign: "center"
});

const Title = ({ children }) => (
  <TitleContainer>
    <StyledTypography>{children}</StyledTypography>
  </TitleContainer>
);

Title.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element])
    .isRequired
};

Title.displayName = "PrivateTitle";

export default Title;
